'use client';

import { useInfiniteQuery } from '@tanstack/react-query';
import Axios from '@/lib/axiosConfig';
import type { ForumResponse, IGroup } from '@/modules/groups/types';

type PublicGroupsPage = ForumResponse<IGroup>;

export const usePublicGroupsList = (
  // Server-rendered first page; see usePublicEducationLists for the rationale.
  initialData?: PublicGroupsPage | null
) => {
  const infiniteQuery = useInfiniteQuery({
    queryKey: ['groups', 'public'],
    queryFn: () => {
      return Axios.get('/groups/public').then((res) => {
        return {
          responseObject: {
            rows: res.data.responseObject || [],
            count: res.data.responseObject?.length || 0,
          },
        };
      });
    },
    initialPageParam: 0,
    getNextPageParam: () => undefined,
    ...(initialData
      ? { initialData: { pages: [initialData], pageParams: [0] } }
      : {}),
  });
  return infiniteQuery;
};
